<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';

export default defineComponent({
  props: {
    message: {
      type: String,
      required: true
    }
  },
  setup(props, { emit }) {
    const text = ref("");
    const counter = ref(0);
    const delay = ref(30);
    const mainText = ref(props.message);
    let typingTimeouts: ReturnType<typeof setTimeout>[] = [];

    const startTypingEffect = () => {
      for (let i = 0; i < mainText.value.length; i++) {
        const timeout = setTimeout(() => {
          text.value += mainText.value[i];
        }, delay.value * counter.value);
        typingTimeouts.push(timeout);
        counter.value += 1;
      }
      const finishTimeout = setTimeout(() => {
        emit("typing-finished");
      }, delay.value * counter.value);
      typingTimeouts.push(finishTimeout);
    };

    const skipTypingEffect = () => {
      typingTimeouts.forEach(timeout => clearTimeout(timeout));
      text.value = mainText.value;
      emit("typing-finished");
    };

    onMounted(() => {
      startTypingEffect();
    });

    return {
      text,
      startTypingEffect,
      skipTypingEffect
    };
  }
});
</script>

<template>
  <div id="container" @click="skipTypingEffect">
    <h4 class="my-2">{{ text }}</h4>
  </div>
</template>

<style lang="scss" scoped>
#container {
  line-height: 1.5;
}
</style>